import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_create_manual_allocation_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { materialId: number, packagingId: number, vendorLotId?: number, lotId?: number, licensePlateId?: number, sourceLocationId?: number, packagedAmount: number, shipmentLineId: number, shippingContainerId?: number, pickTaskId?: number }): Promise<{ reasons?: string[], manualAllocationTaskId?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil($inParams.packagingId)) {
      $missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil($inParams.packagedAmount)) {
      $missingRequiredInParams.push('\'packagedAmount\'');
    }
    if (isNil($inParams.shipmentLineId)) {
      $missingRequiredInParams.push('\'shipmentLineId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

